import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, Spinner } from 'reactstrap';
import { userActions } from '../../actions';
import { selectForgotPassword } from '../../redux/modules/forgotPasswordReducer';
import '../AuthForm.css';

const ForgotPasswordForm = () => {
  const [form, setForm] = useState({
    email: '',
    code: '',
    password: '',
    submitted: false,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forgotPasswordState = useSelector(selectForgotPassword);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm(form => ({
      ...form,
      [name]: value
    }));
  };

  const handleEmailSubmit = (event) => {
    event.preventDefault();
    setForm(form => ({
      ...form, submitted: true
    }));

    if (form.email) {
      setForm(form => ({
        ...form, submitted: false
      }));
      dispatch(userActions.sendPasswordResetCode(form.email));
      event.target.reset();
    }
  };

  const handleCodeSubmit = (event) => {
    event.preventDefault();
    setForm(form => ({
      ...form, submitted: true
    }));

    if (form.email && form.code && form.password) {
      dispatch(userActions.submitPasswordResetCode(form.email, form.code, form.password, navigate));
    }
  };

  const emptyCode = form.submitted && !form.code;
  const emptyPassword = form.submitted && !form.password;
  const emptyEmail = form.submitted && !form.email;
  const loading = forgotPasswordState.loading;
  const emailSubmitted = forgotPasswordState.emailSubmitted;

  if (emailSubmitted) {
    return (
      <div className="auth-wrapper">
        <div className="auth-card">
          <Card>
            <CardBody>
              <div className="auth-header">
                <h2>Reset Password</h2>
                <p>Enter the code from your email and choose a new password</p>
              </div>

              <Form onSubmit={handleCodeSubmit} className="auth-form">
                <FormGroup>
                  <label className="form-label" htmlFor="code">Reset Code</label>
                  <Input
                    invalid={emptyCode}
                    name="code"
                    id="code"
                    placeholder="Enter code from email"
                    onChange={handleChange}
                  />
                  <FormFeedback>Please enter the reset code.</FormFeedback>
                </FormGroup>

                <FormGroup>
                  <label className="form-label" htmlFor="password">New Password</label>
                  <Input
                    type="password"
                    invalid={emptyPassword}
                    name="password"
                    id="password"
                    placeholder="Enter new password"
                    onChange={handleChange}
                  />
                  <FormFeedback>Please enter a new password.</FormFeedback>
                </FormGroup>

                <Button color="primary" disabled={loading}>
                  {loading ? 'Resetting...' : 'Reset Password'}
                </Button>

                {loading && (
                  <div className="auth-spinner">
                    <Spinner type="grow" />
                  </div>
                )}

                <div className="auth-footer">
                  <p>Remember your password? <Link to="/login">Sign in</Link></p>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <Card>
          <CardBody>
            <div className="auth-header">
              <h2>Forgot Password?</h2>
              <p>Enter your email to receive a reset code</p>
            </div>

            <Form onSubmit={handleEmailSubmit} className="auth-form">
              <FormGroup>
                <label className="form-label" htmlFor="email">Email Address</label>
                <Input
                  invalid={emptyEmail}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="you@example.com"
                  onChange={handleChange}
                />
                <FormFeedback>Please enter your email address.</FormFeedback>
              </FormGroup>

              <Button color="primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Code'}
              </Button>

              {loading && (
                <div className="auth-spinner">
                  <Spinner type="grow" />
                </div>
              )}

              <div className="auth-footer">
                <p>Remember your password? <Link to="/login">Sign in</Link></p>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
